import { LocalStorage } from '../../common/helpers/local-storage';
import { SessionStorage } from '../../common/helpers/session-storage';
import { store } from '../../common/redux/configure-store';
import { LoginActions } from '../../common/redux/reducers/login-reducer';
import { login } from './service/login';

export const touchpointLogin = async (): Promise<void> => {
  const computerName = LocalStorage.computerName();
  await login(computerName).then((sessionId): void => {
    updateSessionId(sessionId);
  });
};

const updateSessionId = (sessionId: string): void => {
  store.dispatch(LoginActions.updateUserToken(sessionId));
  SessionStorage.setSessionId(sessionId);
};
